import { useState } from "react";
import "./Report.css";
import { FaSearch } from "react-icons/fa";
import { IoReload } from "react-icons/io5";
import { useSelector } from "react-redux";
import DateFilter from "../../../components/common/DateFilter";

function ReportHeader({
  searchType,
  setSearchText,
  searchText,
  hitFetchApi,
  setParentStartDate,
  setParentEndDate,
  reportType,
  toggleReportType,
}) {
  const role = useSelector((store) => store.userReducer.role);
  const canToggleReport = ["admin", "super", "operation", "mops"].includes(
    role,
  );
  const handleChange = (e, setSearchText) => {
    setSearchText(e.target.value);
  };
  const reloadfunction = () => {
    window.location.reload();
  };

  const handleDateChange = (start, end) => {
    setParentStartDate(start);
    setParentEndDate(end);
  };
  return (
    <div data-tour="filter-payout-transactions">
      <div className="manage-header-report">
        <h2 className="area-top-title-report">
          {reportType === "usdt" ? "USDT Transaction Report" : "Pay Out Report"}
        </h2>
      </div>
      <DateFilter onDateChange={handleDateChange} />
      <div className="search-divs-report-usdt">
        <div className="search-divs-report">
          <div className="search-report">
            <input
              type="text"
              className="search-input-report"
              placeholder="Search By Payout Order ID"
              onChange={(e) => handleChange(e, setSearchText)}
            />
            <FaSearch className="search-icon-report" />
          </div>

          <button
            className="go-btn"
            onClick={() => hitFetchApi(searchType, searchText)}
          >
            Go
          </button>
          <button className="reload-btn" onClick={() => reloadfunction()}>
            <IoReload />
          </button>
        </div>
        {canToggleReport && (
          <button className="toggle-report-btn" onClick={toggleReportType}>
            {reportType === "usdt"
              ? "Payout Report"
              : "USDT Transaction Report"}
          </button>
        )}
      </div>
    </div>
  );
}

export default ReportHeader;
